import { Navigate } from 'react-router-dom'
import { useUserHasRole } from 'src/admin/core/hooks/useUserHasRole'

/**
 * Component that redirects users based on their role
 * - Users with "JS-Flujo-Financiero" role are redirected to financial-flows
 * - Other users are redirected to the default sales-profit-dashboard
 */
const RoleBasedRedirect = () => {
  const { hasRole } = useUserHasRole()

  // Check if user has the financial flows role
  if (hasRole('JS-Fujo-Financiero')) {
    return <Navigate to="statistics/balance-product" replace />
  }

  // Default redirect to sales-profit-dashboard
  return <Navigate to="statistics/sales-profit-dashboard" replace />
}

export default RoleBasedRedirect
